import {
	styled
} from '@payright/web-components';

export const SCLoaderWrapper = styled.div`
  text-align: center;
  margin-top: 6em;
`;

export const SCToolTip = styled.div`
  vertical-align: sub;
  display: inline-block;
  position: relative;
`;